import { useClientAnalytics } from '@ilteducation/client-analytics';

export function usePlanetEarthTracking() {
  const { sendAnalyticsEvent } = useClientAnalytics();

  const sendPoiClickedEvent = (poiName: string) => {
    sendAnalyticsEvent('PlanetEarthEventType', {
      eventName: 'click_poi',
      poiName,
    });
  };

  const sendPoiVideoLinkClickedEvent = (poiName: string, videoId?: string) => {
    sendAnalyticsEvent('PlanetEarthEventType', {
      eventName: 'click_poi_video_link',
      poiName,
      videoId,
    });
  };

  return {
    sendPoiClickedEvent,
    sendPoiVideoLinkClickedEvent,
  };
}
